import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["a-formField", {
            '-has-error': _ctx.errorState,
            '-is-fullwidth': _ctx.config.fullwidth,
        }])
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.config.label && _ctx.placeholderState)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isTranslationLabel)
                ? _withDirectives((_openBlock(), _createElementBlock("label", {
                    key: 0,
                    for: _ctx.config.name,
                    class: "a-formField__placeholder"
                  }, null, 8, _hoisted_1)), [
                    [_directive_translate, _ctx.config.label]
                  ])
                : (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    for: _ctx.config.name,
                    class: "a-formField__placeholder"
                  }, _toDisplayString(_ctx.config.label), 9, _hoisted_2))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.config.inlineSubmit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitAction && _ctx.submitAction(...args))),
          class: "a-formField__action"
        }, [
          _createVNode(_component_IconComponent, {
            "icon-id": _ctx.IconName.ArrowFull
          }, null, 8, ["icon-id"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}